import { TypePage, IPages } from '../_models/TypePage';
import { MyHealthIcon, CalendarIcon, ProfileIcon, CarFleet } from '../../assets/icons';
import { BookIcon } from '../../assets/icons/dashboard';
import NotificationBell from '../../components/NotificationBell';

const mockPage = (page: TypePage) => {
  const pages: IPages = {
    notifications: {
      title: 'Notificações',
      Icon: NotificationBell,
      background: 'linear-gradient(262deg, #FFC107 0%, #FF9E18 100%)',
    },
    schedules: {
      title: 'Agendamentos',
      icon: CalendarIcon,
      background: 'linear-gradient(to right, #ef0019,#ff7685)',
    },
    mySchedules: {
      title: 'Agendamentos',
      icon: CalendarIcon,
      background: 'linear-gradient(to right, #ef0019,#ff7685)',
      backLink: '/agendamentos',
    },
    newSchedule: {
      title: 'Agendamentos',
      mobileTitle: 'Novo Agendamento',
      icon: CalendarIcon,
      background: 'linear-gradient(to right, #ef0019,#ff7685)',
      backLink: '/agendamentos',
    },
    training: {
      title: 'Treinamentos',
      icon: BookIcon,
      background: 'linear-gradient(to right, #3500bf,#0090e1)',
    },
    myHealth: {
      title: 'Minha Saúde',
      icon: MyHealthIcon,
      background: 'linear-gradient(82deg, #E4008B 0%, #E882C4 100%)',
      backLink: '/agendamentos',
    },
    fleets: {
      title: 'Frotas',
      icon: CarFleet,
      background: 'linear-gradient(82deg, #0099d6 45%, #003a50 100%)',
    },
    fleetsQA: {
      title: 'Frotas - FAQ',
      icon: CarFleet,
      background: 'linear-gradient(82deg, #0099d6 45%, #003a50 100%)',
    },
    fleetsCarDescription: {
      title: 'Frotas',
      icon: CarFleet,
      background: 'linear-gradient(82deg, #0099d6 45%, #003a50 100%)',
    },
    fleetsCarSelected: {
      title: 'Frotas',
      icon: CarFleet,
      backLink: '/dashboard',
      background: 'linear-gradient(82deg, #0099d6 45%, #003a50 100%)',
    },
    questions: {
      title: 'Questionário',
      icon: MyHealthIcon,
      background: 'linear-gradient(82deg, #E4008B 0%, #E882C4 100%)',
    },
    profile: {
      title: 'Meu Perfil',
      icon: ProfileIcon,
      background: 'linear-gradient(82deg, #F4743B 0%, #FFD624 100%)',
    },
  };
  return pages[page];
};

export default mockPage;
